import * as sanitize from 'olapic-js-utils/browser/sanitize';
import { get as safeGet } from '../../../lib/safeData';

/**
 * Configures the router with the authentication routes.
 * @param {ngRouteProvider}   $routeProvider    The interface for the AngularJS router.
 * @param {AuthRoutes}        authRoutesManager The dictionary with all the module routes.
 * @ngesdoc config
 * @ngprovider $routeProvider
 * @ngmodule auth
 */
const routeProviderConfig = ($routeProvider, AUTH_ROUTES) => {
  'ngInject';

  $routeProvider
  // Entry point for the authentication process.
  .when(AUTH_ROUTES.auth, {
    template: ({
      client,
      application = '',
      applicationPermissionsRequired = '',
      callback = '',
      accountSelection = '',
      accountScope = '',
      accountId = 0,
      reason = '',
      creatorToken = '',
    }) => `
      <auth-container
        client="${sanitize.string(client)}"
        application="${sanitize.string(application)}"
        application-permissions-required="${sanitize.boolean(applicationPermissionsRequired)}"
        account-selection="${sanitize.boolean(accountSelection)}"
        account-scope="${sanitize.string(accountScope)}"
        account-id="${sanitize.number(accountId)}"
        callback="${sanitize.url(callback)}"
        reason="${sanitize.string(reason)}"
        creator-token="${sanitize.string(creatorToken)}"
      ></auth-container>
    `,
  })
  // Login form.
  .when(AUTH_ROUTES.login, {
    template: ({ state = 'false', error = '' }) => `
      <login-container
        state="${sanitize.boolean(state)}"
        error-code="${sanitize.string(error)}"
      ></login-container>`,
  })
  // Authentication success.
  .when(AUTH_ROUTES.success, {
    template: ({ token = '' }) => {
      const useToken = token ?
        safeGet(sanitize.string(token)) :
        '';

      return `
        <success-container token="${useToken}"></success-container>
      `;
    },
  })
  // _"Remember your password"_.
  .when(AUTH_ROUTES.rememberPassword, {
    template: ({ state = 'false' }) => `
      <remember-password-container
        state="${sanitize.boolean(state)}"
      ></remember-password-container>
    `,
  })
  // _"Reset your password"_.
  .when(AUTH_ROUTES.resetPassword, {
    template: ({ code = '', ref = '' }) => `
      <reset-password-container
        create="false"
        code="${sanitize.string(code)}"
        ref-code="${sanitize.string(ref)}"
      ></reset-password-container>
    `,
  })
  // _"Create your password"_.
  .when(AUTH_ROUTES.createPassword, {
    template: ({ code = '', ref = '' }) => `
      <reset-password-container
        create="true"
        code="${sanitize.string(code)}"
        ref-code="${sanitize.string(ref)}"
      ></reset-password-container>
    `,
  })
  // _"Unauthorized"_.
  .when(AUTH_ROUTES.unauthorized, {
    template: ({ product = '' }) => `
      <unauthorized-container
        product="${sanitize.string(product)}"
      ></unauthorized-container>
    `,
  })
  // Otherwise, redirect to the login screen
  .otherwise({ redirectTo: AUTH_ROUTES.login });
};

export default routeProviderConfig;
